import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import _ from 'lodash';
import { useRouter } from 'next/router';
import Checkbox from '../../Checkbox';
import { PageLinks, UserRolePermissions } from '../../../constants';
import { checkSitePermission } from '../../../store/slices/user';
import { addOrRemoveToCompare } from '../../../store/slices/compare';

const AddToCompare = ({ itineraryId }) => {
  const canSendCompare = useSelector(checkSitePermission(UserRolePermissions.canSendCompare));
  const router = useRouter();
  const { travelAgency } = useSelector((store) => store.user);
  const { searchObj = {} } = useSelector((store) => store.tripSearch);

  const compareSettings =
    travelAgency && travelAgency.settings && travelAgency.settings.compareSettings;

  const doEnableCompare = canSendCompare && router.pathname === PageLinks.Result.url;

  const [doCompare, setDoCompare] = useState(false);
  const dispatch = useDispatch();
  const { track } = useAnalytics();
  const { cruiseOptions, hotelOptions, flightOptions, carOptions, tourOptions } = useSelector(
    (state) => state.compare,
  );
  const { travelOptions } = useSelector((state) => state.tripSearch.searchResult);

  const handleChange = () => {
    dispatch(
      addOrRemoveToCompare({
        travelOptions,
        itineraryId,
        searchObj,
      }),
    );
    track('AddToCompare.handleChange', {
      itineraryId,
    });
  };

  useEffect(() => {
    setDoCompare(
      (cruiseOptions && !!_.find(cruiseOptions, (c) => c.key === itineraryId)) ||
        (hotelOptions && !!_.find(hotelOptions, (c) => c.key === itineraryId)) ||
        (flightOptions &&
          !!_.find(
            flightOptions,
            (c) => c.key === itineraryId || (c.key || '').split('|').includes(itineraryId),
          )) ||
        (tourOptions && !!_.find(tourOptions, (c) => c.key === itineraryId)) ||
        (carOptions && !!_.find(carOptions, (c) => c.key === itineraryId)),
    );
  }, [carOptions, cruiseOptions, flightOptions, hotelOptions, tourOptions, itineraryId]);

  return !doEnableCompare ? (
    <></>
  ) : (
    <Checkbox
      label={(compareSettings && compareSettings.DisplayName) || 'Compare'}
      value={doCompare}
      checked={doCompare}
      onChange={handleChange}
    />
  );
};

AddToCompare.propTypes = {
  itineraryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default AddToCompare;
